'use client';

import Auth from '@/_components/Auth';
import { IRedux } from '@/_store/types';
import { getPage } from '@/_utils/PagesList';
import {
  DrawerBackdrop,
  DrawerBody,
  DrawerContent,
  DrawerRoot,
} from '@/components/ui/drawer';
import { Link, useRouter } from '@/i18n/navigation';
import { Box, Stack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import React, { Dispatch, useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  open: boolean;
  setOpen: Dispatch<boolean>;
}

const Drawer = ({ open, setOpen }: IProps) => {
  const settings = useSelector((state: IRedux) => state.settings);
  const { user } = useSelector((state: IRedux) => state.auth);

  const [isAuthDialog, setIsAuthDialog] = useState(false);
  const [protectedRoute, setProtectedRoute] = useState('');

  const router = useRouter();
  const t = useTranslations();

  return (
    <div>
      <DrawerRoot
        size={'md'}
        open={open}
        placement={'start'}
        onOpenChange={(e) => setOpen(e.open)}
      >
        <DrawerBackdrop
          style={{
            top: '87px',
            zIndex: 29,
          }}
        />
        <DrawerContent
          maxW={'466px'}
          bg={'background.card'}
          style={{
            top: '87px',
            zIndex: 29,
            height: 'calc(100vh - 87px)',
          }}
        >
          <DrawerBody px={'56px'} py={4}>
            <Stack gap={4} fontWeight={500} fontSize={'20px'}>
              {settings?.data?.data?.pages?.map((item) => {
                if (item?.value !== 'my_address') {
                  const page = getPage(item.value);

                  if (page.protected && !user) {
                    return (
                      <Box
                        py={3}
                        key={item?.value}
                        color='dark.cardTitle'
                        _hover={{ color: 'primary' }}
                        onClick={() => {
                          setIsAuthDialog(true);
                          setProtectedRoute(page.route);
                        }}
                      >
                        {t(page.title)}
                      </Box>
                    );
                  }

                  return (
                    <Box
                      py={3}
                      color='text'
                      key={item?.value}
                      _hover={{ color: 'primary' }}
                    >
                      <Link href={page.route}>
                        {page?.type === 'dynamic' ? item?.label : t(page.title)}
                      </Link>
                    </Box>
                  );
                }
              })}
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/delivery-terms'}>
                  {t('delivery_and_payment_terms')}
                </Link>
              </Box>
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/visiting-rules'}>
                  {t('visiting_rules')}
                </Link>
              </Box>
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/public-offer'}>
                  {t('public_offer')}
                </Link>
              </Box>
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/loyaltyoffer'}>
                  {t('loyalty_offer')}
                </Link>
              </Box>
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/llc'}>{t('llc')}</Link>
              </Box>
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/certificate'}>
                  {t('certificate')}
                </Link>
              </Box>
              <Box py={3} color='dark.cardTitle' _hover={{ color: 'primary' }}>
                <Link href={'/return-and-refund-policy'}>
                  {t('return_and_refund_policy')}
                </Link>
              </Box>
            </Stack>
          </DrawerBody>
          <Auth
            open={isAuthDialog}
            onClose={() => setIsAuthDialog(false)}
            onLastConfirm={() =>
              router.push(protectedRoute)
            }
          />
        </DrawerContent>
      </DrawerRoot>
    </div>
  );
};

export default Drawer;
